import { uniqBy } from "lodash";
import { memo, useEffect, useState } from "react";
import { Col, Container, Row } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { useLocation } from "react-router";
import { BzHeading, BzToolTip } from "../../components";
import {
    getAppWaveScreenersDetails,
    getBulkOrBlockDataAction, getFiiDiiMfDataActions, getMergerandAcqDataAction,
    setArrActiveScreenerData, setArrCategoryOptions, setArrFavouritesScreeners, setBIsGridDataShow,
    setPrevScanner, setSelectedCategory
} from "../../redux/actions/screeners";
import { DASHBOARD_EXPLORE_CATEGORY, LOCATIONS, LOCAL_STORAGE_KEYS, SCREENERS_TABS, SIDE_TRAY_EXPAND_PERCENTAGE, DASHBOARD_MENUS } from "../../utils/global_variables";
import ScreenersCards from "./ScreenersCards";
import ScreenersGrid from "./ScreenersGrid";
import ScreenersHeaderTabs from "./ScreenersHeaderTabs";
import ScreenersNav from "./ScreenersNav";
import { ContainerBody, ContainerHeader, GlobalWatchlistScripsModal } from "../Watchlist";
import { getDecryptLocalStorage, setEncryptLocalStorage } from "../../utils/global_functions";
import HoldingsTable from "./HoldingsTable";
import dayjs from "dayjs";
import ScreenersHoldingsGrid from "./ScreenersHoldingsGrid";



const Screeners = ({ isExpanded, setIsExpanded, isExpandCollapse, setIsExpandCollapse, setNActiveCategory, setActiveNav, setToggleSideContainer, setActiveMenu }) => {
    const dispatch = useDispatch();
    const location = useLocation();
    const allScreenersDetails = useSelector(state => state.screeners.allScreenersDetails);
    const arrFavouritesScreeners = useSelector(state => state.screeners.arrFavouritesScreeners);
    const selectedTab = useSelector(state => state.screeners.selectedTab);
    const strSeletedCategory = useSelector(state => state.screeners.strSeletedCategory);
    const objselectedScreener = useSelector(state => state.screeners.objselectedScreener);
    const [isExpandSide, setIsExpandSide] = useState(false);
    const [trayExpanded, setTrayExpanded] = useState(isExpanded?.isTrue);
    const [segment, setSegment] = useState();
    const page = '1';
    const pageSize = "10";
    const jtenantToken = 1;
    const FIIArray = useSelector(state => state.screeners.FIIArray);
    const DIIArray = useSelector(state => state.screeners.DIIArray);
    const MFArray = useSelector(state => state.screeners.MFArray);
    const mergerAndAcqData = useSelector(state => state.screeners.mergerAndAcqData);
    const bulkData = useSelector(state => state.screeners.bulkData);
    const blockData = useSelector(state => state.screeners.blockData);
    const [activeFilter, setActiveFilter] = useState({ filter: 'Near', key: 'Near', id: 0 });


    useEffect(() => {
            dispatch(getAppWaveScreenersDetails());
      }, [dispatch]);


    //Ameersha N - 10-04-2024 -- BREEZE - BT-104814 - Dashboard Screeners --Start
    useEffect(() => {
        if (strSeletedCategory === 'Market' && objselectedScreener?.GroupName === 'Foreign Institution') {
            //call Fii data
            dispatch(getFiiDiiMfDataActions('FII', jtenantToken));
        } else if (strSeletedCategory === 'Market' && objselectedScreener?.GroupName === 'Domestic Institution') {
            // call Di api
            dispatch(getFiiDiiMfDataActions('DII', jtenantToken));
        } else if (strSeletedCategory === 'Market' && objselectedScreener?.GroupName === 'Mutual Funds') {
            // call mf api
            dispatch(getFiiDiiMfDataActions("MF", jtenantToken));
        } else if (strSeletedCategory === 'Market' && objselectedScreener?.GroupName === 'Bulk Deals') {
            // call bulk deals api api
            const bulkFromDate = (new Date(new Date().getTime() - (15 * 24 * 60 * 60 * 1000))).toISOString();
            const bulkToDate = new Date().toISOString();
            dispatch(getBulkOrBlockDataAction({ exchange: 'NSE', dealType: 'bulk', fromDate: dayjs(bulkFromDate).format("DD-MMM-YYYY"), toDate: dayjs(bulkToDate).format("DD-MMM-YYYY"), page: page, pagesize: pageSize, jtenantToken: jtenantToken }));
        } else if (strSeletedCategory === 'Market' && objselectedScreener?.GroupName === 'Block Deals') {
            const blockFromDate = (new Date(new Date().getTime() - (15 * 24 * 60 * 60 * 1000))).toISOString();
            const blockToDate = new Date().toISOString();
            dispatch(getBulkOrBlockDataAction({ exchange: 'NSE', dealType: 'block', fromDate: dayjs(blockFromDate).format("DD-MMM-YYYY"), toDate: dayjs(blockToDate).format("DD-MMM-YYYY"), page: page, pagesize: pageSize, jtenantToken: jtenantToken }));
        } else if (strSeletedCategory === 'Market' && objselectedScreener?.GroupName === 'Merger & Acquisition') {
            // call merger acquistion api

            const mergeFromDate = (new Date(new Date().getTime() - (90 * 24 * 60 * 60 * 1000))).toISOString();
            const mergeToDate = new Date().toISOString();
            dispatch(getMergerandAcqDataAction({ fromDate: dayjs(mergeFromDate).format("DD-MMM-YYYY"), toDate: dayjs(mergeToDate).format("DD-MMM-YYYY"), jtenantToken: jtenantToken }));
        } else { }
    }, [strSeletedCategory, objselectedScreener, dispatch]);
    //Ameersha N - 10-04-2024 -- BREEZE - BT-104814 - Dashboard Screeners --End




    useEffect(() => {
        if (location.pathname === LOCATIONS.DASHBOARD) {
            //Vaibhav S: 15-01-24: BT-109095: Screener logic for Strategy added : Start
            if (selectedTab === SCREENERS_TABS.STRATERGY) {
                if (allScreenersDetails?.length > 0) {
                    const arrCategory = uniqBy((allScreenersDetails?.map(each => each?.Category)));
                    dispatch(setArrCategoryOptions(arrCategory));
                    dispatch(setArrActiveScreenerData(allScreenersDetails?.filter((each) => each?.Category === strSeletedCategory)));
                    if (strSeletedCategory !== "Bullish Strategy" && strSeletedCategory !== "Bearish Strategy") {
                        dispatch(setSelectedCategory("Bullish Strategy"));
                        dispatch(setArrActiveScreenerData(allScreenersDetails?.filter((each) => each?.Category === "Bullish Strategy")));
                    }
                }
            }
            //Vaibhav Singh: 06-03-24:Tab Name updated: Start
            if (selectedTab === SCREENERS_TABS.SCANNERS) {
                if (allScreenersDetails?.length > 0) {
                    let category = (strSeletedCategory !== "Bullish Strategy" && strSeletedCategory !== "Bearish Strategy") ? strSeletedCategory : "Price";
                    const arrCategory = uniqBy((allScreenersDetails?.map(each => each?.Category)));
                    dispatch(setArrCategoryOptions(arrCategory));
                    dispatch(setArrActiveScreenerData(allScreenersDetails?.filter((each) => each?.Category === category)));
                    if (strSeletedCategory === "Bullish Strategy" || strSeletedCategory === "Bearish Strategy") {
                        dispatch(setSelectedCategory("Price"));
                        dispatch(setArrActiveScreenerData(allScreenersDetails?.filter((each) => each?.Category === "Price")));
                    }
                }
            } else if (selectedTab === SCREENERS_TABS.MY_FAVOURITES) {
                // dispatch(setArrCategoryOptions(uniqBy((arrFavouritesScreeners?.map(each => each?.Category)),)));  //as per pdf not showing category in favourites tab will be remove or uncomment in future
                dispatch(setArrActiveScreenerData(arrFavouritesScreeners));
            }
        } else {
            if (selectedTab === SCREENERS_TABS.STRATERGY) {
                if (allScreenersDetails?.length > 0) {
                    const arrCategory = uniqBy((allScreenersDetails?.map(each => each?.Category)));
                    dispatch(setArrCategoryOptions(arrCategory));
                    dispatch(setArrActiveScreenerData(allScreenersDetails?.filter((each) => each?.Category === strSeletedCategory)));
                    if (strSeletedCategory !== "Bullish Strategy" && strSeletedCategory !== "Bearish Strategy") {
                        dispatch(setSelectedCategory("Bullish Strategy"));
                        dispatch(setArrActiveScreenerData(allScreenersDetails?.filter((each) => each?.Category === "Bullish Strategy")));
                    }
                }
            }
            if (selectedTab === SCREENERS_TABS.SCANNERS) {
                if (allScreenersDetails?.length > 0) {
                    let category = (strSeletedCategory !== "Bullish Strategy" && strSeletedCategory !== "Bearish Strategy") ? strSeletedCategory : "Price";
                    const arrCategory = uniqBy((allScreenersDetails?.map(each => each?.Category)));
                    dispatch(setArrCategoryOptions(arrCategory));
                    dispatch(setArrActiveScreenerData(allScreenersDetails?.filter((each) => each?.Category === category)));
                    if (strSeletedCategory === "Bullish Strategy" || strSeletedCategory === "Bearish Strategy") {
                        dispatch(setSelectedCategory("Price"));
                        dispatch(setArrActiveScreenerData(allScreenersDetails?.filter((each) => each?.Category === "Price")));
                    }
                }
                //Vaibhav Singh: 06-03-24:Tab Name updated: End
            } else if (selectedTab === SCREENERS_TABS.MY_FAVOURITES) {
                // dispatch(setArrCategoryOptions(uniqBy((arrFavouritesScreeners?.map(each => each?.Category)),)));  //as per pdf not showing category in favourites tab will be remove or uncomment in future
                dispatch(setArrActiveScreenerData(arrFavouritesScreeners));
            }
            //Vaibhav S: 15-01-24: BT-109095: Screener logic for Strategy added : End
        }
    }, [allScreenersDetails, selectedTab, arrFavouritesScreeners, dispatch]);
    // Vaibhav SIngh: 20-12-23: BT-107427: Added handleBack watchlist logic: Start
    const handleBack = () => {
        if (location.pathname === LOCATIONS.DASHBOARD) {
            // setActiveNav(DASHBOARD_MENUS.INDICES);
            dispatch(setBIsGridDataShow(false));
            setIsExpandCollapse(false);
            setNActiveCategory(DASHBOARD_EXPLORE_CATEGORY.MAIN);
            dispatch(setPrevScanner(null));
        } else {
            setIsExpandSide(false);
        }
    };
    //Vaibhav S: 15-01-24: BT-109095: HandleExpand logic added : Start
    // const handleClickonExpand = () => {
    //     if (arrActiveScannerData?.length) {
    //         let each = arrActiveScannerData[0];
    //         dispatch(getScreenersGridData([{ RedisKeyPrefix: each.RedisKeyPrefix_1, segmentId: 1, indexSector: 'All', month: activeFilter.key }, { RedisKeyPrefix: each.RedisKeyPrefix_2, segmentId: 1, indexSector: 'All' }]));
    //         dispatch(setBIsGridDataShow(true));
    //         arrIndexSectorList?.length < 1 && dispatch(getIndexSectorList());

    //         dispatch(setObjselectedScreener(each));
    //         if (location.pathname === LOCATIONS.DASHBOARD) {
    //             setIsExpandCollapse(true);
    //             setNActiveCategory(DASHBOARD_EXPLORE_CATEGORY.SCREENERS);
    //             dispatch(setArrActiveScreenerData([each]));
    //             if (selectedTab === SCREENERS_TABS.SCANNERS) {
    //                 dispatch(setPrevScanner(each));
    //             }
    //             if (selectedTab === SCREENERS_TABS.MY_FAVOURITES) {
    //                 dispatch(setPrevScanner(null));
    //             }
    //         }
    //         else {
    //             setIsExpandCollapse(true);
    //             if (selectedTab === SCREENERS_TABS.SCANNERS) {
    //                 dispatch(setPrevScanner(each));
    //             }
    //             if (selectedTab === SCREENERS_TABS.MY_FAVOURITES) {
    //                 dispatch(setPrevScanner(null));
    //             }
    //         }
    //     }
    // };
    //Vaibhav S: 15-01-24: BT-109095: HandleExpand logic added : End
    // Vaibhav SIngh: 20-12-23: BT-107427: Added handleBack watchlist logic: End
    useEffect(() => {
        const arrStoredFsvouritesScanners = getDecryptLocalStorage(LOCAL_STORAGE_KEYS.FAVOURITES_SCANNERS);
        if (arrStoredFsvouritesScanners) {
            dispatch(setArrFavouritesScreeners(JSON.parse(arrStoredFsvouritesScanners)));
        }
    }, [dispatch]);
    useEffect(() => {
        setEncryptLocalStorage(LOCAL_STORAGE_KEYS.FAVOURITES_SCANNERS, JSON.stringify(arrFavouritesScreeners));
    }, [arrFavouritesScreeners]);
    useEffect(() => {
        return (() => {
            // dispatch(setSelectedTab(SCREENERS_TABS.STRATERGY));
            dispatch(setBIsGridDataShow(false));
        });
    }, [dispatch]);


    const handleClose = () => {
        setIsExpanded(prevState => { return { ...prevState, isTrue: false, containerLength: SIDE_TRAY_EXPAND_PERCENTAGE.ZERO_PERCENT }; });
        setToggleSideContainer(false);
        setActiveMenu({});
    };

    // <div onClick={() => {
    //     // setTrayExpanded(!isExpanded?.isTrue)
    //     // setIsExpanded(prevState => { return { ...prevState, isTrue: false, containerLength: SIDE_TRAY_EXPAND_PERCENTAGE.ZERO_PERCENT }; });
    //     // setToggleSideContainer(false);
    //     // setActiveNav({});
    //     // setActiveMenu({})

    return (
        <>
            {/* Vaibhav SIngh: 20-12-23: BT-107427: Added  watchlist logic: Start */}
            {location.pathname === LOCATIONS.WATCHLIST ?
                <>
                    <ContainerHeader>
                        <Container fluid className='p-0'>
                            <Row className='g-0 stickysidemenu-top-header bdr-btm p-3'>
                                <Col md={9} className='d-flex justify-content-start align-items-center'>
                                    <div className='font-medium font-size5 color-text text-uppercase line-height-1'>SCREENERS</div>
                                </Col>
                                <Col md={3} className='d-flex justify-content-end align-self-center'>
                                    <BzToolTip placement={'bottom'} TooltipMsg={`${isExpanded?.isTrue ? "Collapse" : "Expand"}`}>
                                        <div onClick={() => {
                                            setTrayExpanded(!isExpanded?.isTrue);
                                            setIsExpanded(prevState => { return { ...prevState, isTrue: !prevState?.isTrue, containerLength: prevState?.isTrue ? SIDE_TRAY_EXPAND_PERCENTAGE?.TWENTY_FIVE_PERCENT : SIDE_TRAY_EXPAND_PERCENTAGE?.SEVENTY_FIVE_PERCENT }; });
                                        }

                                        } className={`icon-16 icon-dark ${isExpanded?.isTrue ? 'icon-collapse' : 'icon-expand'} ms-3`}></div>
                                    </BzToolTip>
                                    <BzToolTip placement={'bottom'} TooltipMsg={'Close'}>
                                        <div onClick={handleClose} className='icon-16 icon-dark icon-close ms-3'></div>
                                    </BzToolTip>
                                </Col>
                            </Row>
                            <Row className='g-0'>
                                <Col>
                                    <ScreenersHeaderTabs isExpandCollapse={isExpandSide} handleBack={handleBack} />
                                </Col>
                            </Row>
                            {/* Bhagyashri P [21-12-2023] : class changes for Sidetray screeners */}
                        </Container>
                    </ContainerHeader>
                    <ContainerBody>
                        <Container fluid className='p-0'>
                            <Row className='g-0'>
                                <Col>
                                    {selectedTab === SCREENERS_TABS.STRATERGY ? (
                                        //Vaibhav S: 15-01-24: BT-109095: Screenr Startegy logic data : Start
                                        isExpandSide ? (
                                            <>
                                                <ScreenersNav segment={segment} setSegment={setSegment} isExpandCollapse={isExpandSide} activeFilter={activeFilter} setActiveFilter={setActiveFilter} handleBack={handleBack} setIsExpandCollapse={setIsExpandSide} trayExpanded={trayExpanded} />
                                                <ScreenersGrid segment={segment} trayExpanded={trayExpanded} />
                                            </>
                                        ) : (
                                            <>
                                                <ScreenersNav segment={segment} setSegment={setSegment} isExpandCollapse={isExpandSide} activeFilter={activeFilter} setActiveFilter={setActiveFilter} handleBack={handleBack} setIsExpandCollapse={setIsExpandSide} trayExpanded={trayExpanded} />
                                                <ScreenersCards setIsExpandCollapse={setIsExpandSide} setNActiveCategory={setNActiveCategory} isExpanded={isExpanded} />
                                            </>
                                        )
                                        //Vaibhav S: 15-01-24: BT-109095: Screenr Startegy logic data : End
                                    ) : selectedTab === SCREENERS_TABS.SCANNERS ? (
                                        isExpandSide ? (
                                            <>
                                                {/* Vaibhav Singh:15-04-24:BT-107427: Added holdings in watchlist tray: Start */}
                                                <ScreenersNav segment={segment} setSegment={setSegment} isExpandCollapse={isExpandSide} setIsExpandCollapse={setIsExpandSide} activeFilter={activeFilter} setActiveFilter={setActiveFilter} handleBack={handleBack} trayExpanded={trayExpanded} />
                                                {/*Ameersha this watchlist sidetray Screeners Holdings Grid will be coming here based on condition */}
                                                {strSeletedCategory === 'Market' && ['Foreign Institution', 'Domestic Institution', 'Mutual Funds']?.includes(objselectedScreener?.GroupName) ?
                                                    <HoldingsTable trayExpanded={trayExpanded} FIIArray={FIIArray} DIIArray={DIIArray} MFArray={MFArray} strSeletedCategory={strSeletedCategory} objselectedScreener={objselectedScreener} />
                                                    : strSeletedCategory === 'Market' && ['Bulk Deals', 'Block Deals', 'Merger & Acquisition']?.includes(objselectedScreener?.GroupName) ?
                                                        <ScreenersHoldingsGrid trayExpanded={trayExpanded} strSeletedCategory={strSeletedCategory} objselectedScreener={objselectedScreener} mergerAndAcqData={mergerAndAcqData} bulkData={bulkData} blockData={blockData} />
                                                        : <ScreenersGrid segment={segment} trayExpanded={trayExpanded} />
                                                }
                                                {/* Vaibhav Singh:15-04-24:BT-107427: Added holdings in watchlist tray: End */}
                                            </>
                                        ) : (
                                            <>
                                                <ScreenersNav segment={segment} setSegment={setSegment} handleBack={handleBack} activeFilter={activeFilter} setActiveFilter={setActiveFilter} isExpandCollapse={isExpandSide} setIsExpandCollapse={setIsExpandSide} trayExpanded={trayExpanded} />
                                                <ScreenersCards setIsExpandCollapse={setIsExpandSide} setNActiveCategory={setNActiveCategory} isExpanded={isExpanded} />
                                            </>
                                        )
                                    ) : selectedTab === SCREENERS_TABS.MY_FAVOURITES ? (
                                        isExpandSide && arrFavouritesScreeners.length ? (
                                            <>
                                                <ScreenersNav segment={segment} setSegment={setSegment} handleBack={handleBack} activeFilter={activeFilter} setActiveFilter={setActiveFilter} isExpandCollapse={isExpandSide} setIsExpandCollapse={setIsExpandSide} trayExpanded={trayExpanded} />
                                                {/*k Hari  - 23-04-2024 -- BREEZE - BT-104814 - Dashboard Screeners - changed -start */}
                                                {strSeletedCategory === 'Market' && ['Foreign Institution', 'Domestic Institution', 'Mutual Funds']?.includes(objselectedScreener?.GroupName) ?
                                                    <HoldingsTable trayExpanded={trayExpanded} FIIArray={FIIArray} DIIArray={DIIArray} MFArray={MFArray} strSeletedCategory={strSeletedCategory} objselectedScreener={objselectedScreener} />
                                                    : strSeletedCategory === 'Market' && ['Bulk Deals', 'Block Deals', 'Merger & Acquisition']?.includes(objselectedScreener?.GroupName) ?
                                                        <ScreenersHoldingsGrid trayExpanded={trayExpanded} strSeletedCategory={strSeletedCategory} objselectedScreener={objselectedScreener} mergerAndAcqData={mergerAndAcqData} bulkData={bulkData} blockData={blockData} />
                                                        : <ScreenersGrid trayExpanded={trayExpanded} segment={segment} />
                                                }
                                                {/*k Hari  - 23-04-2024 -- BREEZE - BT-104814 - Dashboard Screeners - changed -start */}
                                            </>
                                        ) : (
                                            <>
                                                <ScreenersCards setIsExpandCollapse={setIsExpandSide} setNActiveCategory={setNActiveCategory} isExpanded={isExpanded} />
                                            </>
                                        )
                                    ) : null}
                                </Col>
                            </Row>
                        </Container>
                    </ContainerBody>
                </> :
                //Vaibhav SIngh: 20-12-23: BT-107427: Added  watchlist logic: End
                location.pathname === LOCATIONS.DASHBOARD ?
                    <Container fluid className={`p-0 ${isExpandCollapse ? ' screeners-expanded px-3' : ''}`}>
                        <div className='dashboard-cards-wrapper dashboard-screeners'>
                            <Row className='g-0 px-3 dashboard-cards-header align-items-center'>
                                <Col md={3} className='d-flex justify-content-start align-items-center'>
                                    <div className='heading-border'>
                                        <BzHeading className='font-medium font-size8 color-text text-uppercase line-height-1 ms-2'>SCREENERS</BzHeading>
                                    </div>
                                </Col>
                                <Col md={6} className='d-flex justify-content-center align-items-center'>
                                    <ScreenersHeaderTabs isExpandCollapse={isExpandSide} handleBack={handleBack} />
                                </Col>
                                {isExpandCollapse &&
                                    <Col md={3} className='d-flex justify-content-end align-items-center'>
                                        <div data-testid='back-to-dashboard' className='background-icon' onClick={handleBack}>
                                            <div className='icon-16 icon-close icon-dark'></div>
                                        </div>
                                    </Col>
                                }
                            </Row>
                            <div className={`dashboard-cards-container ${isExpandCollapse ? 'mt-3' : 'p-3'}`}>
                                <Container fluid className='p-0'>
                                    <Row className='g-0'>
                                        <Col>
                                            {
                                                selectedTab === SCREENERS_TABS.STRATERGY ? (
                                                    //Vaibhav S: 15-01-24: BT-109095: Screenr Startegy logic data : Start
                                                    isExpandCollapse ? (
                                                        <>
                                                            <ScreenersNav segment={segment} setSegment={setSegment} isExpandCollapse={isExpandCollapse} activeFilter={activeFilter} setActiveFilter={setActiveFilter} />
                                                            <ScreenersGrid segment={segment} />
                                                        </>
                                                    ) : (
                                                        <>
                                                            <ScreenersNav segment={segment} setSegment={setSegment} isExpandCollapse={isExpandCollapse} activeFilter={activeFilter} setActiveFilter={setActiveFilter} />
                                                            <ScreenersCards setIsExpandCollapse={setIsExpandCollapse} setNActiveCategory={setNActiveCategory} />
                                                        </>
                                                    )
                                                    //Vaibhav S: 15-01-24: BT-109095: Screenr Startegy logic data : End
                                                ) : selectedTab === SCREENERS_TABS.SCANNERS ? (
                                                    isExpandCollapse ? (
                                                        <>
                                                            <ScreenersNav segment={segment} setSegment={setSegment} isExpandCollapse={isExpandCollapse} activeFilter={activeFilter} setActiveFilter={setActiveFilter} />
                                                            {strSeletedCategory === 'Market' && ['Foreign Institution', 'Domestic Institution', 'Mutual Funds']?.includes(objselectedScreener?.GroupName) ?
                                                                <HoldingsTable FIIArray={FIIArray} DIIArray={DIIArray} MFArray={MFArray} strSeletedCategory={strSeletedCategory} objselectedScreener={objselectedScreener} />
                                                                : strSeletedCategory === 'Market' && ['Bulk Deals', 'Block Deals', 'Merger & Acquisition']?.includes(objselectedScreener?.GroupName) ?
                                                                    <ScreenersHoldingsGrid trayExpanded={trayExpanded} strSeletedCategory={strSeletedCategory} objselectedScreener={objselectedScreener} mergerAndAcqData={mergerAndAcqData} bulkData={bulkData} blockData={blockData} />
                                                                    : <ScreenersGrid segment={segment} />}
                                                        </>
                                                    ) : (
                                                        <>
                                                            <ScreenersNav segment={segment} setSegment={setSegment} isExpandCollapse={isExpandCollapse} activeFilter={activeFilter} setActiveFilter={setActiveFilter} />
                                                            <ScreenersCards setIsExpandCollapse={setIsExpandCollapse} setNActiveCategory={setNActiveCategory} />
                                                        </>
                                                    )
                                                ) : selectedTab === SCREENERS_TABS.MY_FAVOURITES ? (
                                                    isExpandCollapse && arrFavouritesScreeners.length ? (
                                                        <>
                                                            {/*k Hari  - 23-04-2024 -- BREEZE - BT-104814 - Dashboard Screeners - changed -start */}
                                                            <ScreenersNav segment={segment} setSegment={setSegment} isExpandCollapse={isExpandCollapse} activeFilter={activeFilter} setActiveFilter={setActiveFilter} />
                                                            {strSeletedCategory === 'Market' && ['Foreign Institution', 'Domestic Institution', 'Mutual Funds']?.includes(objselectedScreener?.GroupName) ?
                                                                <HoldingsTable trayExpanded={trayExpanded} FIIArray={FIIArray} DIIArray={DIIArray} MFArray={MFArray} strSeletedCategory={strSeletedCategory} objselectedScreener={objselectedScreener} />
                                                                : strSeletedCategory === 'Market' && ['Bulk Deals', 'Block Deals', 'Merger & Acquisition']?.includes(objselectedScreener?.GroupName) ?
                                                                    <ScreenersHoldingsGrid trayExpanded={trayExpanded} strSeletedCategory={strSeletedCategory} objselectedScreener={objselectedScreener} mergerAndAcqData={mergerAndAcqData} bulkData={bulkData} blockData={blockData} />
                                                                    : <ScreenersGrid segment={segment} />
                                                            }
                                                            {/*k Hari  - 23-04-2024 -- BREEZE - BT-104814 - Dashboard Screeners - changed -end */}
                                                        </>
                                                    ) : (
                                                        <>
                                                            <ScreenersCards setIsExpandCollapse={setIsExpandCollapse} setNActiveCategory={setNActiveCategory} />
                                                        </>
                                                    )
                                                ) : null
                                            }
                                        </Col>
                                    </Row>
                                </Container>
                            </div>
                        </div>
                    </Container>
                    : null}
            <GlobalWatchlistScripsModal />
        </>
    );
};
export default memo(Screeners);